// @ts-strict-ignore
import type { UseEmblaCarouselType } from "embla-carousel-react";
import { useCallback, useEffect, useState } from "react";

import { l } from "@aviary/locales/i18n";

type EmblaCarouselType = UseEmblaCarouselType[1];

type UseDotNavigationType = {
  selectedIndex: number;
  scrollSnaps: number[];
  onDotButtonClick: (index: number) => void;
  renderAriaLabel: (index: number) => string;
};

export const useDotNavigation = (emblaApi: EmblaCarouselType): UseDotNavigationType => {
  const [selectedIndex, setSelectedIndex] = useState(0);
  const [scrollSnaps, setScrollSnaps] = useState<number[]>([]);

  const onDotButtonClick = useCallback(
    (index: number) => {
      if (!emblaApi) return;
      emblaApi.scrollTo(index);
    },
    [emblaApi]
  );

  const onInit = useCallback((api: EmblaCarouselType) => {
    setScrollSnaps(api.scrollSnapList());
  }, []);

  const onSelect = useCallback((api: EmblaCarouselType) => {
    setSelectedIndex(api.selectedScrollSnap());
  }, []);

  useEffect(() => {
    if (!emblaApi) return;

    onInit(emblaApi);
    onSelect(emblaApi);
    emblaApi.on("reInit", onInit);
    emblaApi.on("reInit", onSelect);
    emblaApi.on("select", onSelect);
  }, [emblaApi, onInit, onSelect]);

  const renderAriaLabel = (index: number) =>
    index === selectedIndex ? l.aviary.carousel.slideSelected : l.aviary.carousel.viewNextSlide;

  return {
    selectedIndex,
    scrollSnaps,
    onDotButtonClick,
    renderAriaLabel,
  };
};
